import { connect } from 'react-redux';
import { useCallback } from 'react';

import { AcquaintanceTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/AcquaintanceTypeCodesEnum';
import {
  getActFioReaderBlockId,
  getActTitleReaderBlockId,
  getActRefuserFioBlockId,
  getActRefuserTitleBlockId,
  getActAcquaintanceTypeBlockId,
  getActAcquaintanceLackTypeBlockId,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmErknmFormAct } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormAct';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { TextareaField } from 'UIPackage/MainModule/components/TextareaField';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { SelectInputFieldAutoOptions } from 'UIPackage/MainModule/components/SelectInputFieldAutoOptions';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { KnmLateFieldsRemark } from 'KnmPackage/KnmLateFieldsRemarkModule/components/KnmLateFieldsRemark';

import styles from '../../ErknmActsItem.module.scss';
import { getKnmDataCreated, getKnmFormRef } from '../../../../../KnmPackage/MainModule/selectors/knmSelectors';
import { isLaterThanAdminSetting } from '../../../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from '../../../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from '../../../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { getAdminFetchSettings } from '../../../../../PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IKnmForm } from '../../../../../KnmPackage/MainModule/interfaces/IKnmForm';
import { IAcquaintanceTypeSelectOption } from '../../../../../CorePackage/CatalogsModule/interfaces/IAcquaintanceTypeSelectOption';
import { AcquaintanceLackTypeCodesEnum } from '../../../../../APIPackage/CatalogsModule/enums/AcquaintanceLackTypeCodesEnum';
import { ErknmFieldMark } from '../../../../MainModule/components/ErknmFieldMark';

interface IErknmActsItemProps {
  id: string;
  isDisabledField: boolean;
  name: string;
  value: IKnmErknmFormAct;
  lateFieldName: string;
}

interface IErknmActsItemStoreProps {
  created: string | null | undefined;
  formRef: IKnmFormRef | undefined;
  settings: IAdminSetting[] | undefined;
}

const ErknmActsItemContentAcquaintanceWithoutStore = ({
  id,
  isDisabledField,
  name,
  value,
  created,
  formRef,
  settings,
  lateFieldName,
}: IErknmActsItemProps & IErknmActsItemStoreProps) => {
  // @ts-ignore
  const fioReaderBlockId = getActFioReaderBlockId(id);
  const titleReaderBlockId = getActTitleReaderBlockId(id);
  const refuserFioBlockId = getActRefuserFioBlockId(id);
  const refuserTitleBlockId = getActRefuserTitleBlockId(id);
  const acquaintanceTypeBlockId = getActAcquaintanceTypeBlockId(id);
  const acquaintanceLackTypeBlockId = getActAcquaintanceLackTypeBlockId(id);
  const isAcquaintanceExtended = value.acquaintanceType?.code === AcquaintanceTypeCodesEnum.ACQ_TYPE_I;
  const isAcquaintanceUnextended = value.acquaintanceType?.code === AcquaintanceTypeCodesEnum.ACQ_TYPE_II;
  const isAcquaintanceLackExtended = value.acquaintanceLackType?.code === AcquaintanceLackTypeCodesEnum.ACQ_TYPE_I;
  const isAcquaintanceLackUnextended = value.acquaintanceLackType?.code === AcquaintanceLackTypeCodesEnum.ACQ_TYPE_II;

  const isShow22 = isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.KNM_VALIDATION_4_1_22_STARTS_FROM);

  /**
   * Функция фильтрации значений для поля "Выберите сведение"
   */
  const acquaintanceTypesTransformFunc = useCallback((items: IAcquaintanceTypeSelectOption[]) => {
    return !items ? [] : items.filter(item => item.enabled && !item.disabledBy4122);
  }, []);

  /**
   * Функция очистки зависимых значений при изменении поля "Выберите сведение"
   */
  const onChangeAcquaintanceTypes = useCallback(() => {
    formRef?.current.change(`${name}.fioReader` as keyof IKnmForm);
    formRef?.current.change(`${name}.titleReader` as keyof IKnmForm);
    formRef?.current.change(`${name}.acquaintanceLackType` as keyof IKnmForm);
    formRef?.current.change(`${name}.refuserFio` as keyof IKnmForm);
    formRef?.current.change(`${name}.refuserTitle` as keyof IKnmForm);
    formRef?.current.change(`${name}.acquaintanceLackNoInfoComment` as keyof IKnmForm);
  }, [formRef, name]);

  return (
    <>
      <Row
        title={
          <>
            Сведения об ознакомлении контролируемых лиц с результатами контрольного (надзорного) мероприятия
            <ErknmFieldMark fieldName={`${name}.acquaintanceType`} />
          </>
        }
        align="end"
        notWrap
      >
        {isShow22 ? (
          <SelectInputFieldAutoOptions
            className={styles.AcquaintanceTypeField}
            name={`${name}.acquaintanceType`}
            placeholder="Выберите сведение"
            id={acquaintanceTypeBlockId}
            optionName={CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_TYPES}
            transformFunc={acquaintanceTypesTransformFunc}
            disabled={isDisabledField}
            isClearable={false}
            size="medium"
            onChange={onChangeAcquaintanceTypes}
          />
        ) : (
          <SelectInputFieldAutoOptions
            className={styles.AcquaintanceTypeField}
            name={`${name}.acquaintanceType`}
            placeholder="Выберите сведение"
            optionName={CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_TYPES}
            size="medium"
            disabled={isDisabledField}
            isClearable={false}
          />
        )}

        {isAcquaintanceExtended && (
          <>
            <FieldBlock
              label={
                <>
                  Кто ознакомлен (ФИО)
                  <ErknmFieldMark fieldName={`${name}.fioReader`} />
                </>
              }
              color="black"
              size="col-3"
              margin="right"
              id={fioReaderBlockId}
              tooltip={<KnmLateFieldsRemark lateFieldPath={`${lateFieldName}/fioReader`} fieldId={fioReaderBlockId} />}
            >
              <TextInputField name={`${name}.fioReader`} disabled={isDisabledField} />
            </FieldBlock>

            <FieldBlock
              label={
                <>
                  Должность
                  <ErknmFieldMark fieldName={`${name}.titleReader`} />
                </>
              }
              color="black"
              size="half"
              id={titleReaderBlockId}
              tooltip={
                <KnmLateFieldsRemark lateFieldPath={`${lateFieldName}/titleReader`} fieldId={titleReaderBlockId} />
              }
            >
              <TextInputField name={`${name}.titleReader`} disabled={isDisabledField} />
            </FieldBlock>
          </>
        )}
      </Row>

      {isAcquaintanceUnextended && isShow22 && (
        <Row margin="medium">
          <FieldBlock
            label={
              <>
                Причина неознакомления
                <ErknmFieldMark fieldName={`${name}.acquaintanceLackType`} />
              </>
            }
            margin="right"
            color="black"
            size="col-4"
            tooltip={
              <KnmLateFieldsRemark
                lateFieldPath={`${lateFieldName}/acquaintanceLack`}
                fieldId={acquaintanceLackTypeBlockId}
              />
            }
          >
            <SelectInputFieldAutoOptions
              className={styles.AcquaintanceLackTypeField}
              name={`${name}.acquaintanceLackType`}
              id={acquaintanceLackTypeBlockId}
              optionName={CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_LACK_TYPES}
              size="medium"
              disabled={isDisabledField}
              isClearable={false}
            />
          </FieldBlock>
          {isAcquaintanceLackExtended && (
            <>
              <FieldBlock
                label={
                  <>
                    Кто отказал (ФИО)
                    <ErknmFieldMark fieldName={`${name}.refuserFio`} />
                  </>
                }
                margin="right"
                color="black"
                size="half"
                id={refuserFioBlockId}
                tooltip={
                  <KnmLateFieldsRemark lateFieldPath={`${lateFieldName}/refuserFio`} fieldId={refuserFioBlockId} />
                }
              >
                <TextareaField name={`${name}.refuserFio`} disabled={isDisabledField} resize="none" />
              </FieldBlock>

              <FieldBlock
                color="black"
                size="col-4"
                id={refuserTitleBlockId}
                label={
                  <>
                    Должность/доверенность
                    <ErknmFieldMark fieldName={`${name}.refuserTitle`} />
                  </>
                }
                tooltip={
                  <KnmLateFieldsRemark lateFieldPath={`${lateFieldName}/refuserTitle`} fieldId={refuserTitleBlockId} />
                }
              >
                <TextInputField name={`${name}.refuserTitle`} disabled={isDisabledField} />
              </FieldBlock>
            </>
          )}

          {isAcquaintanceLackUnextended && (
            <FieldBlock
              color="black"
              label={'Комментарий'}
              className={styles.AcquaintanceLackCommentField}
              id={`${id}.acquaintanceLackNoInfoComment`}
              tooltip={
                <KnmLateFieldsRemark
                  lateFieldPath={`${lateFieldName}/acquaintanceLackNoInfoComment`}
                  fieldId={`${id}.acquaintanceLackNoInfoComment`}
                />
              }
            >
              <TextareaField name={`${name}.acquaintanceLackNoInfoComment`} disabled={isDisabledField} resize="none" />
            </FieldBlock>
          )}
        </Row>
      )}
    </>
  );
};

const mapStateToProps = (state: IRootState): IErknmActsItemStoreProps => ({
  created: getKnmDataCreated(state),
  formRef: getKnmFormRef(state),
  settings: getAdminFetchSettings(state),
});

export const ErknmActsItemContentAcquaintance = connect(mapStateToProps)(ErknmActsItemContentAcquaintanceWithoutStore);
